import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { DialogCloseProps } from 'reka-ui'
import { DialogClose } from 'reka-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SheetClose',
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogClose), _mergeProps({ "data-slot": "sheet-close" }, props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})